module.exports = Em.Object.createWithMixins(Em.Evented)
